interface CardProps {
  imagePath: string;
  title: string;
}

const StoreCard: React.FC<CardProps> = ({ imagePath, title }) => {
  return (
    <div className="flex justify-center gap-4 text-white bg-black/90 rounded px-6 py-2 items-center space-between cursor-pointer">
      <img
        alt={title}
        src={imagePath}
        className="w-6 h-6"
      />
      <div className="flex flex-col text-sm">
        <div className="font-thin"> Télécharger dans </div>
        <div className="font-semibold"> {title} </div>
      </div>
    </div>
  );
};

export default StoreCard;
